<template>
  <Modal
    class="common-drawer newModal gate-point"
    v-model="value"
    title="物联配置"
    width="500px"
    :mask-closable="false"
    @on-cancel="closeDrawer"
    class-name="vertical-center-modal"
  >
    <FormTCP ref="formValidate" :defaultFormData="poinitFormDate" v-if="poinitType === 'TCP'" />
    <FormRTU ref="formValidate" :defaultFormData="poinitFormDate" v-else-if="poinitType === 'RTU'" />
    <FormETHERNET ref="formValidate" :defaultFormData="poinitFormDate" v-if="poinitType === 'ETHERNET'" />
    <div class="drawer-footer" slot="footer">
      <Button
        type="primary"
        @click="submitForm"
        :loading="btnLoading"
        >提交</Button
      >
      <Button style="margin-left: 8px" @click="closeDrawer">取消</Button>
    </div>

    <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
  </Modal>
</template>

<script>
import { configureParms } from "@/api/knowledge/gateway";
import FormTCP from './form-TCP.vue';
import FormETHERNET from './form-ETHERNET.vue';
import FormRTU from "./form-RTU.vue";

export default {
  components: { FormTCP, FormETHERNET, FormRTU },
  name: "getpoint",
  props: [
    "value",
    "poinitType",
    "poinitFormDate",
    "getList",
    "modelmehods",
    "timbo",
  ],
  data() {
    return {
      btnLoading: false,
    };
  },
  methods: {
    closeDrawer() {
      this.$emit("input", false);

      let t = setTimeout(() => {
        this.rest();
        clearTimeout(t);
      }, 300);
    },
    rest() {
      this.$refs.formValidate.resetFields();
    },
    submitForm(name1) {
      this.$refs["formValidate"].validate((valid, deviceInfo) => {
        if (valid) {
          try {
            // this.btnLoading = true;
            const { gatewayDriverId, gatewayOilSiteId, gatewayId, oilSiteId } =
              this.poinitFormDate;

            const form = {
              gatewayDriverId,
              gatewayOilSiteId,
              oilSiteId: oilSiteId,
              deviceInfo,
              gatewayId,
            };

            this.$emit("change", { form: this.$c.deepClone(form) });
            this.closeDrawer();
            // configureParms(form)
            //   .then((res) => {
            //     if (res.code === "00000") {
            //       this.$Message.success(res.data);
            //       this.getList();
            //       this.closeDrawer();
            //     } else {
            //       this.$Message.info(res.data);
            //     }
            //   })
            //   .catch((error) => {});
          } catch (error) {}

          this.btnLoading = false;
        } else {
        }
      });
    },
  },
};
</script>
<style lang="less">
.gate-point {
  .title {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-bottom: 20px;
  }
}
.gate-point {
  .ivu-modal {
    top: 1% !important;
  }
}
</style>